// Testimonial Carousel - Coverflow Slider
document.addEventListener('DOMContentLoaded', function () {
  const testimonialSection = document.querySelector('[data-testimonial-section]');
  if (!testimonialSection) return;

  // === SLIDER FUNCTIONALITY ===
  const sliderContainer = testimonialSection.querySelector('[data-testimonial-slider]');

  if (sliderContainer && typeof Swiper !== 'undefined') {
    const swiperEl = sliderContainer.querySelector('.swiper');
    const swiperWrapper = swiperEl.querySelector('.swiper-wrapper');
    const autoplaySpeed = parseInt(testimonialSection.dataset.autoplaySpeed) || 5000;

    // Navigation buttons
    const prevButton = testimonialSection.querySelector('.testimonial-prev');
    const nextButton = testimonialSection.querySelector('.testimonial-next');

    // Duplicate slides if there aren't enough for looping
    const originalSlides = swiperWrapper.querySelectorAll('.swiper-slide');
    const slideCount = originalSlides.length;

    if (slideCount > 0 && slideCount < 4) {
      // Duplicate slides to ensure smooth looping
      const slidesToAdd = 4 - slideCount;
      for (let i = 0; i < slidesToAdd; i++) {
        const clonedSlide = originalSlides[i % slideCount].cloneNode(true);
        swiperWrapper.appendChild(clonedSlide);
      }
    }

    const enableLoop = true;

    const testimonialSwiper = new Swiper(swiperEl, {
      effect: 'coverflow',
      grabCursor: false,
      centeredSlides: true,
      loop: enableLoop,
      loopAdditionalSlides: 2,
      slidesPerView: 1.5,
      speed: 600,
      autoplay: {
        delay: autoplaySpeed,
        disableOnInteraction: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      allowTouchMove: true,
      simulateTouch: true,
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 16,
          coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 0,
            modifier: 2,
            slideShadows: false,
          },
        },
        749: {
          spaceBetween: 20,
        },
        989: {
          slidesPerView: 1.4,
          spaceBetween: 20,
          coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 0,
            modifier: 2,
            slideShadows: false,
          },
        },
        1240: {
          slidesPerView: 1.5,
          spaceBetween: 20,
          coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 0,
            modifier: 2,
            slideShadows: false,
          },
        },
      },
      on: {
        afterInit: function () {
          // Wait 500ms after init, then fade in
          setTimeout(() => {
            sliderContainer.classList.add('swiper-initialized');
          }, 500);
        },
      },
    });



    // Connect navigation buttons
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        testimonialSwiper.slidePrev();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        testimonialSwiper.slideNext();
      });
    }
  }
});
